import React, { useState, useEffect } from 'react';
import axios from 'axios';
import clearIcon from '../../assets/weather/sunny.png';
import partlyCloudyIcon from '../../assets/weather/cloud.png';
import cloudyIcon from '../../assets/weather/cloud.png';
import rainIcon from '../../assets/weather/rainy-day.png';
import snowIcon from '../../assets/weather/snowflake.png';
import thunderstormIcon from '../../assets/weather/rainy-day.png';
import mistIcon from '../../assets/weather/windy.png';

const Header = () => {
  const [time, setTime] = useState('');
  const [day, setDay] = useState('');
  const [date, setDate] = useState('');
  const [weather, setWeather] = useState('');
  const [weatherIcon, setWeatherIcon] = useState('');

  const fetchWeather = async () => {
    try {
      const response = await axios.get('https://wttr.in/YOUR_CITY?format=%C+%t');
      const [weatherDescription, temperature] = response.data.split('+');
      console.log(response.data);
      setWeather(`${weatherDescription} · ${temperature}`);
      setWeatherIcon(getWeatherIcon(weatherDescription.trim()));
    } catch (err) {
    }
  };

  const getWeatherIcon = (description) => {
    const iconMap = {
      'Clear': clearIcon,
      'Sunny': clearIcon,
      'Partly': partlyCloudyIcon,
      'Partly cloudy': partlyCloudyIcon,
      'Cloudy': cloudyIcon,
      'Overcast': cloudyIcon,
      'Mist': mistIcon,
      'Fog': mistIcon,
      'Light rain': rainIcon,
      'Heavy rain': rainIcon,
      'Rain': rainIcon,
      'Snow': snowIcon,
      'Light snow': snowIcon,
      'Thunderstorm': thunderstormIcon,
    };
    return iconMap[description] || mistIcon;
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
      setDay(now.toLocaleDateString('en-US', { weekday: 'long' }));
      setDate(now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }));
    };

    updateTime();
    const interval = setInterval(updateTime, 30000);
    fetchWeather();

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="main-header">
      <div className="header-left">
        <span>{day}, {date} · {time}</span>
        {/* {weather && (
          <span className="weather-display">
            · <img src={weatherIcon} alt="Weather" /> {weather}
          </span>
        )} */}
      </div>
    </header>
  );
};

export default Header;
